module.exports = __webpack_public_path__ + "img/金属材料学5_3.f70f5868.png";